<template>
  <div>
    <section>
      <ul
        class="news-list"
        v-infinite-scroll="loadMore"
        infinite-scroll-disabled="loading"
        infinite-scroll-distance="20"
      >
        <li v-for="item in newsList" :key="item.ID">
          <router-link :to="{name: 'news-detail',params: {id:item.ID}}">
            <div class="img">
              <img
                class="img"
                :src="item.TitleImagePath !=null?item.TitleImagePath +'?x-oss-process=image/resize,m_pad,h_132,w_200,color_ffffff':defaultImg"
                :onerror="defaultImg"
                alt
              >
            </div>
            <div class="main-content">
              <h5 style="-webkit-box-orient: vertical;">{{item.ContentTitle}}</h5>
              <span>{{item.PublishedTime}}</span>
            </div>
          </router-link>
        </li>
      </ul>
    </section>
    <Empty v-if="isEmpty"></Empty>
    <div class="status-hint" v-show="pageHint">{{pageHint}}</div>
    <footer-logo></footer-logo>
  </div>
</template>

<script>
import footerLogo from '@/components/footerLogo.vue'
import Empty from '@/views/statePage/empty.vue'
export default {
  components: {
    Empty,
    'footer-logo': footerLogo
  },
  data() {
    return {
      pageHint: '',
      isEmpty: false,
      loading: false,
      newsList: [],
      newsData: {
        title: '',
        type: 'EntNews',
        pageIndex: 1,
        pageSize: 10
      },
      totalPage: -1,
      defaultImg: 'this.src="' + require('@/assets/images/defaultImg.png') + '"'
    }
  },
  created() {
    var category = this.$route.params.category
    if (category) {
      this.newsData.type = category
    }
    this.getNewsList()
  },
  methods: {
    getNewsList() {
      this.pageHint = '加载中...'
      var _this = this
      this.$fetch('/api/News/GetNewsList', this.newsData).then(result => {
        this.isLoading = false
        _this.totalPage = result.PageCount
        if (this.newsData.pageIndex >= this.totalPage) {
          this.pageHint = '没有更多了'
        } else {
          this.pageHint = '上拉加載更多'
        }
        if (result.Items && result.Items.length > 0) {
          this.newsList = this.newsList.concat(result.Items)
          this.isEmpty = false
        } else {
          this.isEmpty = true
          this.pageHint = ''
        }
      })
    },
    loadMore() {
      if (this.newsData.pageIndex >= this.totalPage) {
        this.loading = false
      } else {
        this.loading = true
        this.pageHint = '加载中...'
        setTimeout(() => {
          this.newsData.pageIndex++
          this.getNewsList()
        }, 1500)
      }
    }
  }
}
</script>

<style lang="less" scoped>
section {
  width: 100%;
  background: #fff;
  border-bottom: 20 / @rem-size solid #f7f7f7;

  .news-list {
    padding: 0 24 / @rem-size;

    li {
      display: flex;
      margin-top: 25 / @rem-size;
      padding-bottom: 25 / @rem-size;
      border-bottom: 1px solid #e6e6e6;
      position: relative;

      .label {
        width: 80 / @rem-size;
        height: 40 / @rem-size;
        font-size: 24 / @rem-size;
        text-align: center;
        line-height: 40 / @rem-size;
        position: absolute;
        top: 16 / @rem-size;
        left: 0;
        margin: auto;
      }

      &:last-child {
        border: none;
      }

      a {
        display: flex;
      }

      .img {
        width: 200 / @rem-size;
        height: 132 / @rem-size;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .main-content {
        flex: 1;
        margin-left: 22 / @rem-size;

        h5 {
          font-size: 0.3rem;
          color: #333;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          max-width: 4.9rem;
          font-weight: 500;
          line-height: 46 / @rem-size;
          max-height: 92 / @rem-size;
        }

        span {
          display: block;
          margin-top: 10 / @rem-size;
          color: #999;
          font-size: 28 / @rem-size;
        }
      }
    }
  }
}
</style>
